export const DAY_INDEX = {
  sunday: 0,
  sun: 0,
  monday: 1,
  mon: 1,
  tuesday: 2,
  tue: 2,
  tues: 2,
  wednesday: 3,
  wed: 3,
  thursday: 4,
  thu: 4,
  thur: 4,
  thurs: 4,
  friday: 5,
  fri: 5,
  saturday: 6,
  sat: 6,
};

const DAY_RE =
  /(sunday|monday|tuesday|wednesday|thursday|friday|saturday|sun|mon|tues?|wed|thurs?|thu|fri|sat)/i;

// La ventana para PEDIR el permiso de aterrizaje no es horario de oficina.
// KCVG/KLUK: "7 days per week, 0800-2200  Permission to land requests
// 0900-1700 ET" — la oficina abre 0800-2200; 0900-1700 es cuándo se atienden
// las SOLICITUDES. Este parser se quedaba con el PRIMER rango del texto, así
// que acertaba de casualidad: si CBP invirtiera el orden, el chip pintaría la
// ventana de solicitudes como si fuera el horario de la oficina, sin avisar.
// Gemelo de PTL_REQUEST_WINDOW_RE en backend/cbp_hours.py — los dos parsers
// deben recortar lo mismo o la pantalla y el motor dirían cosas distintas.
const PTL_REQUEST_WINDOW_RE =
  /permission\s+to\s+land\s+requests?\s*:?\s*\d{3,4}\s*[-–]\s*\d{3,4}/gi;

export function parseOfficeHours(raw) {
  if (!raw) return null;
  const s = String(raw).trim().replace(PTL_REQUEST_WINDOW_RE, " ");

  const tzMatch = s.match(/\(([A-Z]{2,4})\)/);
  const tz = tzMatch ? tzMatch[1] : null;

  const has247 = /\b24\s*\/\s*7\b/.test(s);
  const has24h = has247 || /\b24\s*(?:hours?|hrs?\.?)\b/i.test(s);
  const has7days = has247 || /7\s*days?\s*(per\s*week|a\s*week|\/\s*w(ee)?k)/i.test(s);

  const dayRange = s.match(new RegExp(`${DAY_RE.source}\\s*[-–]\\s*${DAY_RE.source}`, "i"));
  let dayStart = null;
  let dayEnd = null;
  if (dayRange) {
    dayStart = DAY_INDEX[dayRange[1].toLowerCase()];
    dayEnd = DAY_INDEX[dayRange[2].toLowerCase()];
  } else if (has7days) {
    dayStart = 1;
    dayEnd = 0;
  }

  const timeMatch = s.match(/(\d{3,4})\s*[-–]\s*(\d{3,4})/);
  let hours = null;
  if (timeMatch) {
    const fmt = (n) => {
      const p = n.padStart(4, "0");
      return `${p.slice(0, 2)}:${p.slice(2)}`;
    };
    hours = `${fmt(timeMatch[1])}–${fmt(timeMatch[2])}`;
  }

  if (has24h && has7days && !timeMatch) {
    return { always: true, dayStart: null, dayEnd: null, hours: null, tz, ok: true };
  }

  if (dayStart !== null || hours || tz) {
    return { always: false, dayStart, dayEnd, hours, tz, ok: dayStart !== null || !!hours };
  }
  return null;
}

export const CBP_TZ_TO_IANA = {
  ET: "America/New_York",
  EST: "America/New_York",
  EDT: "America/New_York",
  CT: "America/Chicago",
  CST: "America/Chicago",
  CDT: "America/Chicago",
  MT: "America/Denver",
  MST: "America/Denver",
  MDT: "America/Denver",
  PT: "America/Los_Angeles",
  PST: "America/Los_Angeles",
  PDT: "America/Los_Angeles",
  AKT: "America/Anchorage",
  AKST: "America/Anchorage",
  AKDT: "America/Anchorage",
  HT: "Pacific/Honolulu",
  HST: "Pacific/Honolulu",
  AST: "America/Halifax",
  ADT: "America/Halifax",
};

export function zoneOffsetHours(ianaZone, when = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: ianaZone,
      timeZoneName: "shortOffset",
    }).formatToParts(when);
    const tz = parts.find((p) => p.type === "timeZoneName")?.value || "";
    const m = tz.match(/GMT([+-])(\d{1,2})(?::(\d{2}))?/);
    if (!m) return null;
    const sign = m[1] === "-" ? -1 : 1;
    return sign * (parseInt(m[2], 10) + (m[3] ? parseInt(m[3], 10) / 60 : 0));
  } catch {
    return null;
  }
}

export function formatDelta(hours) {
  if (hours === 0) return null;
  const sign = hours > 0 ? "+" : "−";
  const abs = Math.abs(hours);
  const str = Number.isInteger(abs) ? `${abs}` : `${abs.toFixed(1)}`;
  return `${sign}${str}h`;
}
